module.exports = __webpack_public_path__ + "img/hungaro.6845d5d7.svg";